import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';

const Stream = ({ iframe }) => {
  const pos = iframe.indexOf(`iframe`);
  const embed = `${iframe.slice(0, pos + 6)} allowFullScreen="true" ${iframe.slice(pos + 7)}`;

  return (
    <div className="ratio-16-9">
      {renderHTML(embed)}
    </div>
  );
};

Stream.propTypes = {
  iframe: PropTypes.string.isRequired,
};

export default Stream;



// WEBPACK FOOTER //
// ./library/app/components/Content/Stream.js